import { injectGlobal } from '@emotion/css'
import { colors, lineHeight, fontWeight, fontFamily, fontSize, spacing } from '@offerzen/pinata-shame'

injectGlobal({
  '*, *::after, *::before': {
    boxSizing: 'inherit',
  },
  html: {
    boxSizing: 'border-box',
  },
  body: {
    margin: 0,
    backgroundColor: colors.catskillWhite,

    // Rails scss was handling the text and link styles in the dashboard, but now we have to have it here.
    // If dashboard was using piñata components and text styles this would not be a problem.
    fontFamily: fontFamily.body,
    color: colors.jumbo,
    fontSize: fontSize.default,
    lineHeight: lineHeight.default,

    'p, h1, h2, h3, h4, h5, h6': {
      margin: 0,
      marginBottom: spacing.default,
    },

    a: {
      textDecoration: 'none',
      color: colors.cornflowerBlue,
    },
  },

  strong: {
    fontWeight: fontWeight.semiBold,
  },

  '.grecaptcha-badge': {
    visibility: 'hidden',
  },
})
